import { Group } from '@mantine/core';
import { sortBy, uniqBy } from 'lodash-es';
import { observer } from 'mobx-react-lite';
import type { Reaction } from '../../../api';
import { InlineEmoji } from '../../../components/InlineEmojiPicker/InlineEmoji';
import { InlineEmojiPicker } from '../../../components/InlineEmojiPicker/InlineEmojiPicker';

export const Reactions = observer(
	({
		reactions,
		onToggle,
		canReact,
	}: {
		reactions: Reaction[];
		onToggle: ({ native }: { native: string }) => void;
		canReact: boolean;
	}) => (
		<Group spacing="xs">
			{sortBy(uniqBy(reactions, 'emoji'), 'emoji')
				.filter((f) => f.users.length > 0)
				.map(({ emoji, users }) => (
					<InlineEmoji
						key={emoji}
						emoji={emoji}
						users={users}
						onToggle={onToggle}
					/>
				))}
			{canReact && <InlineEmojiPicker onClick={onToggle} />}
		</Group>
	)
);
